export const MedicationReconciliationControllerFactory = ({
  medicationReconciliationService,
}: {
  medicationReconciliationService: IMedicationReconciliationService;
}): IMedicationReconciliationController => {
  const uploadDischargePdf: IUploadDischargePdf = async (payload) => {
    const result = await medicationReconciliationService.uploadDischargePdf(
      payload
    );

    if (result.success) {
      return {
        success: true,
        data: result.data,
      };
    }
    return {
      success: false,
      error: result.error,
    };
  };

  const getDischargePdfUploads: IGetDischargePdfUploads = async (payload) => {
    const result = await medicationReconciliationService.getDischargePdfUploads(
      payload
    );

    if (result.success) {
      return {
        success: true,
        data: result.data,
      };
    }
    return {
      success: false,
      error: result.error,
    };
  };

  return {
    uploadDischargePdf,
    getDischargePdfUploads,
  };
};
